import { useMutation, useQueryClient } from "react-query";
import { userGenerateDashboard } from "@/services/user";
import { useHandleGenerateResult } from "@/hooks/useHandleGenerateResult";
import { useEdit, useError } from "@/states/common.state";
import { useIsloading } from "@/states/ui.state";
import { QrTypeProps } from "../../data/builder-qr.type";
import useQrPayloadStore from "../../data/builder.store";

const useUpdateQrConfig = (selectedType: QrTypeProps) => {
  const queryClient = useQueryClient();

  const { handleGenerateResult } = useHandleGenerateResult();
  const addOrUpdateData = useQrPayloadStore.getState().addOrUpdateData;
  const { setIsloading } = useIsloading();
  const { setError } = useError.getState();
  const { isEdit } = useEdit();

  const {
    mutate: setUserQrGenerateConfigUpdate,
    isLoading: isLoadingConfigUpdate,
    error,
    isError,
    isSuccess,
    isIdle,
  } = useMutation(
    (params: Record<string, any>) => {
      return userGenerateDashboard.updateQrConfig(selectedType.id!, { config: { ...params } });
    },
    {
      onSuccess: (data) => {
        handleGenerateResult(data);
        setIsloading(false);
        isEdit && queryClient.invalidateQueries(["QR_LIST"]);
        isEdit && queryClient.invalidateQueries(["ANALYTICS_SHOW"]);
        if (data.data) {
          addOrUpdateData(selectedType.qr_type, {
            config: data.data.config,
          });
        }
      },
      onError: ({ response }) => {
        setError(response?.data?.errors);
        setIsloading(false);
      },
    },
  );

  const updateQrConfig = (params: Record<string, any>) => {
    if (selectedType.id) {
      setIsloading(true);
      setUserQrGenerateConfigUpdate(params);
    }
  };

  return { updateQrConfig, isLoadingConfigUpdate, error, isError, isSuccess };
};

export default useUpdateQrConfig;
